<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Antecipação de Garantias</b>
            </h3>
            <router-link
              v-if="$store.state.user.nivel == 1"
              tag="a"
              class="btn btn-primary pull-right"
              to="/operacao/antecipacoes/nova"
            >
              <i class="fa fa-plus"></i> Simular
            </router-link>
          </div>
          <div class="box-body">
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%">Data</th>
                      <th style="width: 10%">Qtd. de Boletos</th>
                      <th style="width: 10%">Total Boletos</th>
                      <th style="width: 10%">Prorata</th>
                      <th style="width: 10%">Taxa</th>
                      <th style="width: 10%">Total da Antecipação</th>
                      <th style="width: 10%">Situação</th>
                      <th style="width: 9%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                      <td>{{ item.created_at | dataHoraFormatada }}</td>
                      <td>{{ item.qtd_boletos }}</td>
                      <td>{{ item.total_boletos | numberFormat(2, ',', '.') }}</td>
                      <td>{{ item.total_prorata | numberFormat(2, ',', '.') }}</td>
                      <td>{{ item.total_taxa_antecipacao | numberFormat(2, ',', '.') }}</td>

                      <td>
                        <strong>{{ item.total_antecipacao | numberFormat(2, ',', '.') }}</strong>
                      </td>
                      <td>{{ item.situacao }}</td>
                      <td>
                        <button
                          class="btn btn-info btn-sm"
                          title="Visualizar"
                          @click="getAntecipacao(item.id)"
                        >
                          <i class="fa fa-fw fa-file"></i>
                        </button>
                        <button
                          v-if="$store.state.user.nivel == 2 && item.situacao === 'EM ANÁLISE'"
                          class="btn btn-success btn-sm"
                          title="Aprovar"
                          @click="aprovaAntecipacao(item.id)"
                        >
                          <i class="fa fa-fw fa-thumbs-up"></i>
                        </button>
                         <button
                          v-if="$store.state.user.nivel == 2 && item.situacao === 'EM ANÁLISE'"
                          class="btn btn-danger btn-sm"
                          title="Negar"
                          @click="negaAntecipacao(item.id)"
                        >
                          <i class="fa fa-fw fa-thumbs-down"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="apiData"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
export default {
  data: () => ({
    dados: {
      filtro: ""
    },
    apiData: {
      data: []
    }
  }),
  mounted() {
    this.getDataTable();
  },

  methods: {
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/relatorio/getAllAntecipacao`,
          config
        )
        .then(response => {
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    aprovaAntecipacao(antecipacaoId) {
      this.$swal({
        title: "Aprova solicitação de antecipação?",
        text: "Voce não poderá reverter essa operação!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, confirmo!"
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/relatorio/aprovaAntecipacao/${antecipacaoId}`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDataTable();
              window.open(
                `${this.$store.state.serverURI}/api/relatorio/getAntecipacao/${antecipacaoId}`,
                "_blank"
              );
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    negaAntecipacao(antecipacaoId) {
      this.$swal({
        title: "Negar solicitação de antecipação?",
        text: "Voce não poderá reverter essa operação!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, confirmo!"
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/relatorio/negaAntecipacao/${antecipacaoId}`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDataTable();
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },

    getAntecipacao(antecipacaoId) {
          window.open(
            `${this.$store.state.serverURI}/api/relatorio/getAntecipacao/${antecipacaoId}`,
            "_blank"
          );
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },

  components: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?0ed947c7